<div class="row justify-content-center">
    <div class="col">
        <h5>
            {{ 'email-confirmation-subtitle' | cmsText | async }}
        </h5>
        <div class="alert alert-info" [innerHTML]="'email-confirmation-text' | cmsText | async"></div>
    </div>
</div>
